const Container = ({ children }) => (
  <div className=" max-w-[1240px] m-auto  scroll-smooth font-display">
    {children}
  </div>
);
export default Container;
